import { render, staticRenderFns } from "./AreaAddTabInfo.vue?vue&type=template&id=6830800b"
import script from "./AreaAddTabInfo.vue?vue&type=script&lang=ts"
export * from "./AreaAddTabInfo.vue?vue&type=script&lang=ts"
import style0 from "./AreaAddTabInfo.vue?vue&type=style&index=0&id=6830800b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports